
import { Vue, Component, Prop } from 'vue-property-decorator'

// inner components
import SurveyPreview from './SurveyPreview.vue'
import EligibilityPreview from './EligibilityPreview.vue'
import PhotoPreview from './PhotoPreview.vue'
import QuestionPreview from './QuestionPreview.vue'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'
import GoalPreview from '~/components/common/modals/application-review/previewModal/GoalPreview.vue'

@Component({
  name: 'PreviewModal',
  components: {
    CloseCrossCtrl,
    SurveyPreview,
    EligibilityPreview,
    PhotoPreview,
    QuestionPreview,
    GoalPreview
  }
})
export default class PreviewModal extends Vue {
  @Prop({ default: '' }) requirementAlias!: string
  @Prop() requirementTitle!: string
  @Prop() photo!: string
  @Prop() surveys!: string
  @Prop() eligibility!: string
  @Prop() question!: string
  @Prop() goal!: string

  get component() {
    if (this.requirementAlias === 'survey') { return SurveyPreview }
    if (this.requirementAlias === 'special eligibility') { return EligibilityPreview }
    if (this.requirementAlias === 'photo') { return PhotoPreview }
    if (this.requirementAlias === 'question') { return QuestionPreview }
    if (this.requirementAlias === 'goal') { return GoalPreview }
  }
}
